import { platform } from "~/platform/socket";
import LinksGQL from "../graphql/links.gql?raw";
import type { List } from "../types/list";

export const LINK_TYPES = ["link", "vimeo", "youtube"] as const;

export async function fetchLinks(id: string): Promise<List> {
	const result = await platform.query<{ list: List }>(LinksGQL, { id });

	const constructed = {
		...result.list,
		sections: result.list.sections
			.map((section) => ({
				...section,
				items: section.items.filter((item) => LINK_TYPES.includes(item.type)),
			}))
			.filter((section) => section.items.length > 0),
	};

	return constructed;
}
